module.exports = __webpack_public_path__ + "img/mottoImg2.1ca568f4.jpg";